module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Détection BAS.e013e6b848da49f13c1e085de396c5da.pdf";